/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { a as getRealWebUrl } from '../../../common-42e7d8d8.js';
import '../../../safe-data-66f20265.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';

function navigateTo(params, context) {
    var _a;
    var api = 'dd.biz.util.openLink';
    (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params, {
        formatInput: function (input) {
            return { url: getRealWebUrl(input) };
        },
    });
}

export { navigateTo as default };
